import {
  AttachedProductDto,
  GetAttachedProductQueryParams,
  GetPodQueryParams,
  GetProductQueryParams,
  GetTenantQueryParams,
  GetTenantSubscriptionByidQueryParams,
  GetTenantTypeQueryParams,
  GetTenantVerifysubdomainQueryParams,
  ProductDto,
  TenantDto,
  TenantSubscriptionDto,
  TenantTypeDto
} from 'src/models/tenantadmin';
import { GetAxiosInstance } from '../baseService';
import { ServiceLocation } from '../serviceLocationsAxios';

/**
 * Get tenant for pod
 *
 * @param params
 * @returns
 */
export const getPod = (params?: GetPodQueryParams) => {
  return GetAxiosInstance().get<string>(ServiceLocation.tenantadmin + '/pod', {
    params
  });
};

/**
 * Get Tenants
 * @param params GetTenantQueryParams
 * @returns TenantDto[]
 */
export const getTenants = (params?: GetTenantQueryParams) => {
  return GetAxiosInstance().get<TenantDto[]>(ServiceLocation.tenantadmin + '/Tenant', { params });
};

/**
 * Get Tenant Subscription by Id
 * @param id Id of the Tenant
 * @param params GetTenantSubscriptionByidQueryParams
 * @returns TenantSubscriptionDto
 */
export const getTenantSubscriptionById = (id: string, params?: GetTenantSubscriptionByidQueryParams) => {
  return GetAxiosInstance().get<TenantSubscriptionDto>(ServiceLocation.tenantadmin + '/Tenant/subscription/' + id, {
    params
  });
};

/**
 * Get Products
 * @param params GetProductQueryParams
 * @returns ProductDto[]
 */
export const getProducts = (params?: GetProductQueryParams) => {
  return GetAxiosInstance().get<ProductDto[]>(ServiceLocation.tenantadmin + '/Product', { params });
};

/**
 * Get Attached Products
 * @param params GetAttachedProductQueryParams
 * @returns AttachedProductDto[]
 */
export const getAttachedProducts = (params?: GetAttachedProductQueryParams) => {
  return GetAxiosInstance().get<AttachedProductDto[]>(ServiceLocation.tenantadmin + '/AttachedProduct', { params });
};

/**
 * Verify Tenant Subdomain
 * @param params GetTenantVerifysubdomainQueryParams
 * @returns boolean
 */
export const verifyTenantSubdomain = (params: GetTenantVerifysubdomainQueryParams) => {
  return GetAxiosInstance().get<boolean>(ServiceLocation.tenantadmin + '/Tenant/verifysubdomain', { params });
};

/**
 * Get Tenant Type
 * @param params GetTenantTypeQueryParams
 * @returns TenantTypeDto[]
 */
export const getTenantType = (params?: GetTenantTypeQueryParams) => {
  return GetAxiosInstance().get<TenantTypeDto[]>(ServiceLocation.tenantadmin + '/TenantType', { params });
};
